<template>
  <div class="class-charts">
    <!-- 分类得分情况 -->
 
     <div class="canvas-box" ref="heartBarX" style="height:90px; margin-top: 10px;" v-if="this.model.length + 1 != 2"></div>
    <div class="canvas-box" ref="heartBarX" style="height:70px; margin-top: 10px;" v-if="this.model.length + 1 == 2"></div>
  </div>
</template>
<script>
export default {
  props: ["model", "name1", "score1"],
  data() {
    return {
      name: [],
      score: [],
      score2: [],
      size: 14,
    };
  },
  mounted() {
    this.renderMap();
  },
  watch: {},
  methods: {
    renderMap() {
      this.name.push(this.name1);
      this.score2.push(this.score1);
      this.model.map((item) => {
        this.name.push(item.name);
        this.score.push(item.score);
      });
      let heartBarX = (window.cc = this.$echarts.init(
        this.$refs['heartBarX'],
        null,
        {
          renderer: "svg",
        }
      ));
      let option = {
        grid: {
          top: "0.5%",
          left: "1.8%",
          right: "11%",
          bottom: "2.5%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "category",
            data: this.name,
            inverse: true,
            axisTick: { show: false }, // 刻度
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14,
                color: "black",
              },
                formatter: function (data1, data2) {
                if (data2 == 0) {
                  return "{b|" + data1 + "}";
                } else {
                  return data1;
                }
              },
               rich: {
                b: {
                  fontWeight: "bold",
                  fontSize: 15,
                },
              },
            },
            axisLine: {
              lineStyle: {
                color: "#D1E0EF",
              },
            },
          },
        ],
        xAxis: {
          max: 10,
          min: 0,
          interval: 2,
          type: "value",
          axisLine: { show: false }, // 轴线
          axisTick: { show: false }, // 刻度
          splitLine: { show: false }, // 分隔线
          axisLabel: {
            textStyle: {
              fontSize: 0,
            },
          },
        },
        series: [
           {
            type: "bar",
            //  barGap:'40%',
            barWidth: 40,
            data: this.score2,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  let colors = ["#A1D46B"];
                  return colors[params.dataIndex];
                },
              },
            },
          },
          {
            type: "bar",
             barGap:'20%',
            barWidth: this.size,
            data: this.score,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  let colors = [ "#C3ED97", "#C3ED97"];
                  return colors[params.dataIndex];
                },
              },
            },
          },
        ],
      };

      heartBarX.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.class-charts {
  position: relative;
  .canvas-box {
    width: 307px;
    // height: 90px;
    // margin-top:10px;
    margin-left:18px;
    // margin: 10px auto 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/all/heartBarAll/heartBarX.vue